import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb6c0f24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mission" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contain-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "introduction__video",
    src: "https://www.youtube.com/embed/0QwFGYBWDiA?autoplay=1&mute=1",
    title: "T&D - Apresentação Escola GTOP",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerpolicy: "strict-origin-when-cross-origin",
    allowfullscreen: "",
    "data-iframe": ""
  })
], -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "mission__content" }
const _hoisted_5 = { class: "mission__image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item__content item__title" }
const _hoisted_8 = { class: "item__content item__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missions, (mission) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "item",
          key: mission
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "icon",
                src: 
                require(`../../assets/static/landingPageGTop/${mission.image}`)
              ,
                alt: "icon"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(mission.title), 1)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(mission.description), 1)
        ]))
      }), 128))
    ])
  ]))
}